if(!document.getElementById("switchForm")) {
    let switchForm = document.createElement("form");
    switchForm.id = "switchForm";
    document.body.appendChild(switchForm);
}